<template>
  <div class="add-versions">
    <el-form
      :model="versionsForm"
      :rules="versionsRules"
      ref="versionsForm"
      class="demo-versionsForm"
      label-position="left"
    >
      <el-row>
        <el-col :span="14">
          <el-form-item label="app名称" prop="name">
            <el-input
              v-model="versionsForm.name"
              show-word-limit
              maxlength="40"
              placeholder="请输入app名称"
              class="text-input"
            ></el-input>
          </el-form-item>

          <el-form-item label="系统类型" prop="systemType">
            <el-select
              style="margin-right: 12px"
              v-model="versionsForm.systemType"
              placeholder="请选择系统类型"
            >
              <el-option
                v-for="item in getDictDatas(DICT_TYPE.SYSTEM_TYPE)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="更新类型" prop="updateType">
            <el-select
              v-model="versionsForm.updateType"
              placeholder="请选择更新类型"
            >
              <el-option
                v-for="item in getDictDatas(DICT_TYPE.UPDATE_TYPE)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备品牌" prop="manufacturer">
            <el-select
              v-model="versionsForm.manufacturer"
              placeholder="请选择设备品牌"
            >
              <el-option
                v-for="item in getDictDatas(DICT_TYPE.MANUFACTURER)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="版本号" prop="versionNo">
            <el-input
              v-model="versionsForm.versionNo"
              placeholder="请输入版本号"
              class="text-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="更新描述" prop="updateDescription">
            <el-input
              v-model="versionsForm.updateDescription"
              placeholder="请输入更新描述"
              class="text-input"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 10 }"
            ></el-input>
          </el-form-item>
          <el-form-item label="下载链接">
            <div class="upload-url">
              <el-input
                v-model="versionsForm.url"
                placeholder="请输入下载链接"
                class="text-input"
              ></el-input>
              <upload-img
                uploadName="上传"
                accept="apk/*"
                @uploadInfo="uploadInfo"
                fileDir="apkurl"
                :resultImg="versionsForm.url"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-table
            :data="versionsForm.versionGameCompatibilityList"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
            border
            max-height="600"
          >
            <el-table-column prop="gameName" label="游戏"> </el-table-column>
            <el-table-column prop="isAvailable" label="是否可用">
              <template slot-scope="{ row }">
                <el-select v-model="row.isAvailable" placeholder="是否可用">
                  <el-option
                    v-for="item in availableList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="info" label="不可用说明">
              <template slot-scope="{ row }">
                <el-input
                  type="textarea"
                  v-model="row.info"
                  placeholder="不可用说明"
                  :autosize="{ minRows: 1, maxRows: 3 }"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-form-item class="handlebox">
        <el-button
          type="primary"
          @click="submitForm('versionsForm')"
          class="enter-btn save-btn"
          :loading="submitLoading"
          >确认{{ type === "add" ? "添加" : "修改" }}</el-button
        >
        <el-button
          @click="resetForm('versionsForm')"
          class="cancel-btn calloff-btn"
          >取消</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import UploadImg from "../../../components/UploadImg/index.vue";
import { uploadVersions, getVersionsGame } from "@/api/login";
import { getAllSportsGameList } from "@/api/unity";
export default {
  components: {
    UploadImg,
  },
  data() {
    return {
      versionsForm: {
        systemType: "",
        updateType: "",
        name: "",
        versionNo: "",
        updateDescription: "",
        url: "",
        manufacturer: "",
        versionGameCompatibilityList: [],
      },
      versionsRules: {
        systemType: [
          { required: true, message: "请选择系统类型", trigger: "change" },
        ],
        manufacturer: [
          { required: true, message: "请选择设备品牌", trigger: "change" },
        ],
        updateType: [
          { required: true, message: "请选择更新类型", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入app名称", trigger: "blur" }],
        versionNo: [
          { required: true, message: "请输入版本号", trigger: "blur" },
        ],
        updateDescription: [
          { required: true, message: "请输入更新描述", trigger: "blur" },
        ],
      },
      availableList: [
        { value: 1, label: "可用" },
        { value: 0, label: "不可用" },
      ],
      submitLoading: false,
      firstList: [],
      secondList: [],
      id: "",
      type: "add",
    };
  },
  async created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    const res = await getAllSportsGameList();
    if (this.type === "edit") {
      const localForm = JSON.parse(localStorage.getItem("versionInfo"));
      this.$nextTick(async () => {
        this.versionsForm = {
          ...localForm,
          systemType: String(localForm.systemType),
          updateType: String(localForm.updateType),
          manufacturer: String(localForm.manufacturer),
          versionGameCompatibilityList: [],
        };
        const res1 = await getVersionsGame(localForm.id);
        const existingList = res1.result || [];
        const toAdd = res.result
          .filter(
            (game) =>
              !existingList.some((existing) => existing.gameId === game.id)
          )
          .map((el) => ({
            gameId: el.id,
            gameName: el.gameName,
            info: "",
            isAvailable: 1,
          }));
        this.versionsForm.versionGameCompatibilityList = [
          ...existingList,
          ...toAdd,
        ];
      });
    } else {
      this.versionsForm.versionGameCompatibilityList = res.result.map((el) => {
        return {
          gameId: el.id,
          gameName: el.gameName,
          info: "",
          isAvailable: 1,
        };
      });
    }
  },
  mounted() {},
  methods: {
    // 获取上传地址
    uploadInfo(info) {
      this.$nextTick(() => {
        this.versionsForm.url = info;
      });
    },
    // 新建版本
    submitForm(formName) {
      console.log(this.versionsForm);
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.versionsForm.systemType === 1 && !this.versionsForm.url) {
            this.$message.error("请上传下载地址");
            return;
          }
          this.submitLoading = true;
          await uploadVersions(this.versionsForm);
          this.$message.success("添加成功！");
          this.$router.go(-1);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.add-versions {
  .text-input {
    width: 444px;
  }
  .number-input {
    width: 216px;
  }
  ::v-deep .demo-versionsForm {
    .el-form-item__label {
      white-space: nowrap;
      min-width: 100px;
    }
    .handlebox {
      text-align: right;
      margin-top: 20px;
    }
    input[aria-hidden="true"] {
      display: none !important;
    }
    .upload-url {
      display: flex;
      align-items: center;
      .text-input {
        margin-right: 16px;
      }
    }
  }
}
</style>
